export const get = (state) => {
  return state.children
}

export const getById = (state) => (id) => {
  return state.children.find(child => child.id === id)
}

export const getPrimaryDevice = (state) => (id) => {
  let child = state.children.find(child => child.id === id)

  if (child.devices.length === 0) {
    return null
  }

  return child.devices.find(device => device.is_primary)
}

export const getSearches = (state) => (id) => {
  const child = state.children.find(child => child.id === id)

  return _.has(child, 'searches') ? child.searches : []
}

export const getYoutubeSearches = (state) => (id) => {
  const child = state.children.find(child => child.id === id)

  return _.has(child, 'youtube_searches') ? child.youtube_searches : []
}

export const getYoutubeViews = (state) => (id) => {
  const child = state.children.find(child => child.id === id)

  return _.has(child, 'youtube_views') ? child.youtube_views : []
}

export const getBlocksAndAlerts = (state) => (id) => {
  const child = state.children.find(child => child.id === id)

  return _.has(child, 'blocks_and_alerts') ? child.blocks_and_alerts : []
}

export const getProtectedSocialMedia = (state) => (id) => {
  const child = state.children.find(child => child.id === id)

  const settings = child.protected_social_media_settings.filter(setting => {
    return setting.app_name !== 'Facebook' && setting.app_name !== 'Instagram'
  })

  return _.has(child, 'protected_social_media_settings')
    ? _.orderBy(settings, 'app_name')
    : []
}

export const getUnsupportedSocialMedia = (state) => (id) => {
  const child = state.children.find(child => child.id === id)

  return _.has(child, 'unsupported_social_media_settings')
    ? _.orderBy(child.unsupported_social_media_settings, 'app_name')
    : []
}

export const getAllSocialMedia = (state) => (id) => {
  const child = state.children.find(child => child.id === id)

  if (
    _.has(child, 'protected_social_media_settings') &&
    _.has(child, 'unsupported_social_media_settings')
  ) {
    return child.protected_social_media_settings.concat(
      child.unsupported_social_media_settings
    )
  }

  return []
}

export const getFacebookAndInstagram = (state) => (id) => {
  const child = state.children.find(child => child.id === id)

  return child.protected_social_media_settings.filter(setting => {
    return setting.app_name === 'Facebook' || setting.app_name === 'Instagram'
  })
}

export const getCategorySettings = (state) => (id) => {
  const child = state.children.find(child => child.id === id)

  return _.has(child, 'category_settings') ? child.category_settings : []
}

export const getTimeblocks = (state) => (id) => {
  const child = state.children.find(child => child.id === id)
  const time_blocks = _.cloneDeep(child.time_blocks)

  return time_blocks.map(time_block => {
    let time_block_mode = child.modes.find(mode => mode.id === time_block.mode_id)

    return {
      ...time_block,
      mode_name: time_block_mode.name,
      user_id: child.id
    }
  })
}

export const getAndroidApps = (state) => (id) => {
  const child = state.children.find(child => child.id === id)

  if(_.has(child, 'android_apps'))
  {
    return child.android_apps.sort(function (a, b) {
      return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
    });
  }
  else
  {
    return [];
  }
}

export const getIosApps = (state) => (id) => {
  const child = state.children.find(child => child.id === id)

  if(_.has(child, 'ios_apps'))
  {
    return child.ios_apps.sort(function (a, b) {
      return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
    });
  }
  else
  {
    return [];
  }
}

export const getAppSettings = (state) => (id) => {
  const child = state.children.find(child => child.id === id)

  return _.has(child, 'app_settings') ? child.app_settings : []
}

export const getUrlSettings = (state) => (id) => {
  const child = state.children.find(child => child.id === id)

  return _.has(child, 'url_settings') ? child.url_settings : []
}